export default class Selection<T> {
    private selectedItems: T[];

    constructor() {
        this.selectedItems = [];
    }

    public add(item: T) {
        this.selectedItems.push(item);
    }

    public toggle(item: T) {
        const indexOfItem = this.selectedItems.indexOf(item);

        if (indexOfItem >= 0) {
            this.selectedItems.splice(indexOfItem, 1);
        } else {
            this.selectedItems.push(item);
        }
    }

    public getAll(): T[] {
        return this.selectedItems.slice();
    }

    public clear() {
        this.selectedItems = [];
    }

    public contains(item: T): boolean {
        return this.selectedItems.includes(item);
    }
}
